import logging from '@/assets/js/functions/_core/logging';
import store from "@/store";
import firebase from "firebase";

export default {
  mixins: [logging],

  methods: {
    subCollectionDocRef(collectionName, documentId, subCollectionName) {
      return firebase.firestore().collection(collectionName).doc(documentId).collection(subCollectionName)
    },

    async getSubCollectionDocument(subCollectionDocRef, documentId) {
      store.dispatch('cover/toggleLoadCover');
      let readDoc = null;
      await subCollectionDocRef.doc(documentId).get().then(doc => {
        readDoc = doc.data();
      }).catch(error => {
        store.dispatch('cover/toggleLoadCover');
        this.logger(error, 'データの取得に失敗しました');
        throw error;
      });
      store.dispatch('cover/toggleLoadCover');
      return readDoc;
    },

    async retrieveSubCollectionDocs(query) {
      store.dispatch('cover/toggleLoadCover');
      let readDocs = [];
      await query.get().then(docs => {
        docs.forEach(doc => {
          readDocs.push(doc.data());
        });
      }).catch(error => {
        store.dispatch('cover/toggleLoadCover');
        this.logger(error, "データの読み込みに失敗しました");
        throw error;
      });
      store.dispatch('cover/toggleLoadCover');
      return readDocs;
    },

    async createSubCollectionDocument(subCollectionDocRef, documentId, requestParams) {
      store.dispatch('cover/toggleLoadCover');

      const defaultParams = {
        isDeleted: false,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      };
      const params = {...defaultParams, ...requestParams};

      if (documentId) {
        await subCollectionDocRef.doc(documentId).set(
          params
        ).catch(error => {
          store.dispatch('cover/toggleLoadCover');
          this.logger(error, 'データの取得に失敗しました');
          throw error;
        });
      } else {
        await subCollectionDocRef.add(
          params
        ).catch(error => {
          store.dispatch('cover/toggleLoadCover');
          this.logger(error, 'データの登録に失敗しました');
          throw error;
        });
      }
      store.dispatch('cover/toggleLoadCover');
    },

    async updateSubCollectionDocument(subCollectionDocRef, documentId, requestParams) {
      store.dispatch('cover/toggleLoadCover');

      const defaultParams = {
        updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      };
      const params = {...defaultParams, ...requestParams};
      console.log(documentId)
      console.log(params)
      await subCollectionDocRef.doc(documentId).update(
        params
      ).catch(error => {
        store.dispatch('cover/toggleLoadCover');
        this.logger(error, 'データの更新に失敗しました');
        throw error;
      });
      store.dispatch('cover/toggleLoadCover');
    }
  }
}
